const initialState = {
	isEligibilityChecking: false,
	isTransferringRequest: false,
	notEligible: false,
	validEligibility: false
};

const retrialEligibleReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "IS_ELIGIBILITY_CHECKING":
			state = {
				...state,
				isEligibilityChecking: action.payload
			};
			break;
		case "IS_TRANSFERRING_REQUEST":
			state = {
				...state,
				isTransferringRequest: action.payload
			};
			break;
		case "NOT_ELIGIBLE":
			state = {
				...state,
				notEligible: action.payload
			};
			break;
		case "VALID_ELIGIBILITY":
			state = {
				...state,
				validEligibility: action.payload
			};
			break;
		default:
			return state;
	}
	return state;
};

export default retrialEligibleReducer;
